const MobileDetails = ({ onEnquire }) => {
  return (
    <div className="px-5 py-6 text-center">
      <span className="inline-block bg-lime-700 text-white text-sm px-3 py-1 rounded-full">
        Booking Open
      </span>

      <h2 className="text-2xl font-bold mt-3">GODREJ VARANYA KHARGHAR</h2>
      <p className="text-lg text-gray-600">By Godrej Properties</p>

      <p className="text-sm text-gray-500 mt-1">
        Sector 5A, Kharghar-Belapada, Navi Mumbai
      </p>

      <div className="grid grid-cols-2 gap-3 mt-5 text-sm font-bold">
        <div className="bg-lime-100 py-2 rounded-lg">₹40L Benefits*</div>
        <div className="bg-lime-100 py-2 rounded-lg">EOI ₹2L*</div>
        <div className="bg-lime-100 py-2 rounded-lg">20 Min Airport</div>
        <div className="bg-lime-100 py-2 rounded-lg">2 Min Metro</div>
      </div>

      <div className="mt-5">
        <p className="text-sm">Luxury 2 & 3 BHK Starts</p>
        <p className="text-2xl font-bold text-lime-700">₹ 2.25 Cr* Onwards</p>
      </div>

      <button
        className="mt-5 w-1/2 bg-[#7c9a1f] text-white py-3 rounded-xl font-medium shadow-lg active:scale-95 transition"
        onClick={onEnquire}
      >
        Enquire Now
      </button>
    </div>
  );
};

export default MobileDetails;
